<template>
  <Admin>
    <v-main v-if="!isProductListLoading" class="wrapper">
        <v-container v-if="!selectedCompanyProductList?.isFixedAssetCount" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
        ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
            <h1>Fixed Assets Count</h1>
        </div>
        <v-divider/> 
        <v-row justify="center">
          <v-col>
            <assetsCountTable></assetsCountTable>
          </v-col>
        </v-row>
        <v-row justify="start" class="tw-my-4">
          <v-col>
            <select class="items-per-page-selector" v-model="itemsPerPage" :disabled="isLoading">
              <option
                v-for="option in itemsPerPageOptions"
                :key="option"
                :value="option"
                :selected="option === itemsPerPage"
              >
                {{ option }}
              </option>
            </select>
          </v-col>
          <v-col>
            <v-pagination
              v-model="currentPage"
              :length="numPages"
              :total-visible="10"
              :disabled="isLoading"
            ></v-pagination>
          </v-col>
          <v-col class="tw-flex tw-items-end tw-justify-end">
            <p class="total-item">จำนวนรายการทั้งหมด: {{ totalItems }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>
<script >
import Admin from '@/components/admin/admin-main-template.vue'
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import {mapState, mapActions, mapMutations} from "vuex";
import assetsCountTable from '@/components/admin/fixedAssets/assetsCountTable.vue';
import getRole from "@/libs/getRole";
const axios = require('axios');

export default {
    name: "fixedAssetSessionCount",
    components: {
        Admin,
        assetsCountTable
    },
    data(){
        return {
            sysnSuccess: false,
            itemsPerPageOptions: [10, 20, 30, 40, 50],
        }
    },
    computed: {
        ...mapState({
          assetCounts: (state) => state.fixedAssets.assetCounts,
          selectedCompanyProductList: (state) =>
            state.companies.selectedCompanyProductList,
          isProductListLoading: (state) => state.companies.isProductListLoading,
          pagination: (state) => state.fixedAssets.assetsCountPagination,
          isLoading: (state) => state.fixedAssets.isLoading,
          user: (state) => state.user.userData,
          userCompany: (state) => state.user.userCompany,
        }),
        
        // Role checking
        role() {
          const userCompany = this.userCompany || {};
          return {
            owner: this.checkRole(userCompany) === "owner" && !userCompany?.isDeveloper,
            developer: this.checkRole(userCompany) === "developer",
            engineer: this.user?.isEngineer,
            admin: userCompany?.isAdmin,
            user: this.checkRole(userCompany) === "user"
          };
        },
        
        // Developer or Engineer
        isDevOrEngineer() {
          return this.role.developer || this.role.engineer;
        },
        itemsPerPage: {
          get() {
            return this.pagination?.itemsPerPage || 10;
          },
          set(value) {
            const companyId = this.$route.params.companyId || localStorage.getItem('companyId');
            this.$store.dispatch('fixedAssets/changeAssetsCountItemsPerPage', {
              companyId,
              itemsPerPage: parseInt(value),
              userEmail: this.user?.email || null,
              isUserRole: this.role.user && !this.role.owner && !this.isDevOrEngineer
            });
          }
        },
        currentPage: {
          get() {
            return this.pagination.currentPage;
          },
          set(value) {
            const companyId = this.$route.params.companyId || localStorage.getItem('companyId');
            this.$store.dispatch('fixedAssets/goToAssetsCountPage', {
              companyId,
              page: value,
              userEmail: this.user?.email || null,
              isUserRole: this.role.user && !this.role.owner && !this.isDevOrEngineer
            });
          }
        },
        numPages() {
          return this.pagination.totalPages;
        },
        totalItems() {
          return this.pagination.totalItems;
        },
    },
    methods: {
      ...mapMutations({
        clearAssetCounts: 'fixedAssets/setAssetCounts'
      }),
      ...mapActions({
        clearAllListeners: 'fixedAssets/clearAllListeners'
      }),
      // Role checking method
      checkRole(userCompany) {
        return getRole(userCompany);
      }
    },
    beforeDestroy() {
      // Clear asset counts data when leaving the page to prevent
      // syncItemsPerPageFromLocalStorage from triggering fetchAssetCount on other pages
      this.clearAssetCounts([]);
      // Clean up Firestore listeners
      this.clearAllListeners();
    }
};
</script>

<style scoped>
.items-per-page-selector {
  padding: 0.3rem .5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.items-per-page-selector:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

.total-item {
  margin-bottom: 0;
  font-size: 0.9rem;
}
</style>